/**
 * Checks if any navigation filters have changed from their initial default values.
 *
 * @param {object} params - Parameters.
 * @param {object} params.state - Current state.
 * @param {object} params.initialValues - Initial values for competition, season, and round to compare against.
 * @returns {object} Object containing boolean flags indicating changes.
 */
export const useHasChangedFromDefaults = ({ state, initialValues }) => {
    let hasChangedFromDefaults = false;

    // Check for comp change
    const isCompetitionChanged =
        initialValues?.competitionId &&
        state.nav?.competition?.id !== parseInt(initialValues?.competitionId);

    // Check for season change
    const isSeasonChanged =
        initialValues?.seasonId &&
        state.nav?.season?.id !== parseInt(initialValues?.seasonId);

    // Check for round change
    const isRoundChanged =
        initialValues?.roundId &&
        state.nav?.round?.id !== parseInt(initialValues?.roundId);

    // Check for category change
    const isCategoryChanged =
        initialValues?.category &&
        state.nav?.category !== initialValues?.category;

    // Check for data type change
    const isDataTypeChanged =
        initialValues?.dataType &&
        state?.dataType.type !== initialValues?.dataType;

    // Check for benchmarking change
    const isBenchmarkingChanged =
        (initialValues?.benchmarking ||
            initialValues?.benchmarking === false) &&
        state?.benchmarking?.isActive !== initialValues?.benchmarking;

    // Check for teams change
    const isTeamsChanged = state?.filters?.teams.length > 0;

    // Check for positions change
    const isPositionsChange = state?.filters?.positions.length > 0;

    // Check for single team change
    const isTeamChanged =
        (initialValues?.team || initialValues?.team === -1) &&
        initialValues.team !== state?.team.id;

    if (
        isCompetitionChanged ||
        isSeasonChanged ||
        isRoundChanged ||
        isCategoryChanged ||
        isDataTypeChanged ||
        isBenchmarkingChanged ||
        isTeamsChanged ||
        isPositionsChange ||
        isTeamChanged
    ) {
        hasChangedFromDefaults = true;
    }

    return {
        hasChangedFromDefaults,
        isCompetitionChanged,
        isSeasonChanged,
        isRoundChanged,
        isCategoryChanged,
        isDataTypeChanged,
        isBenchmarkingChanged,
        isTeamsChanged,
        isPositionsChange,
        isTeamChanged
    };
};
